import React from 'react';
import { XButtonBottom } from '../../x/button/bottom/XButtonBottom';
import { useActiveOrderManager } from '../../../hooks/useActiveOrderManager';
import { useCurrency } from '../../../hooks/currency';
import { useToggle } from '../../../hooks/toggle';
import { SpcCheckout } from '../../../spc/checkout/SpcCheckout';
import styled from 'styled-components';

const Wrapper = styled.div`
    .service-fee {
        position: absolute;
        top: 2px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 10px;
        font-weight: bold;
        color: white;
    }
`;

export function OrderCheckout() {
    const currency = useCurrency();
    const activeOrderManager = useActiveOrderManager();
    const [isCheckoutOpen, toggleIsCheckoutOpen] = useToggle();

    if (!activeOrderManager.hasActiveOrder()) {
        return null;
    }

    const totalCost = activeOrderManager.getTotalPrice();
    const serviceFee = activeOrderManager.getServiceFee();

    return (
        <Wrapper>
            <XButtonBottom onClick={toggleIsCheckoutOpen} color="primary">
                {serviceFee > 0 && (
                    <div className="service-fee">Includes OrderX fee: {currency.format(serviceFee)}</div>
                )}
                Place order {totalCost > 0 && currency.format(totalCost)}
            </XButtonBottom>

            {isCheckoutOpen && <SpcCheckout onClose={toggleIsCheckoutOpen} />}
        </Wrapper>
    );
}
